var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showTableContent,
          expression: "showTableContent",
        },
      ],
      staticClass: "directory-order-table-components",
    },
    [
      !!_vm.items
        ? _c("div", { staticClass: "table-header-bar" }, [
            _c("div", { staticClass: "header-left-block float-left" }, [
              _c("label", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.titleMap[_vm.viewType])),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "directory-table-content" }, [
        _c(
          "table",
          { staticClass: "directory-order-table" },
          [
            _c("thead", [
              _c(
                "tr",
                [
                  _c(
                    "th",
                    {
                      staticClass: "tenancyId",
                      on: {
                        click: function () {
                          _vm.handleSortHeaderClick("tenancyId")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("directory.label.tenancyRecordId")) +
                          "\n            "
                      ),
                      _c("i", { class: _vm.generateSortClass("tenancyId") }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "tenantName",
                      on: {
                        click: function () {
                          _vm.handleSortHeaderClick("tenantName")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("directory.label.tenantName")) +
                          "\n            "
                      ),
                      _c("i", { class: _vm.generateSortClass("tenantName") }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.headers, function (header) {
                    return _c(
                      "th",
                      {
                        key: header.attr,
                        class: header.cls,
                        on: {
                          click: function () {
                            _vm.handleSortHeaderClick(header.attr)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(header.title) +
                            "\n            "
                        ),
                        _c("i", { class: _vm.generateSortClass(header.attr) }),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.isFloor
                    ? _c(
                        "th",
                        {
                          staticClass: "premises",
                          on: {
                            click: function () {
                              _vm.handleSortHeaderClick("premises")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("directory.label.premises")) +
                              "\n            "
                          ),
                          _c("i", { class: _vm.generateSortClass("premises") }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "effective-date",
                      on: {
                        click: function () {
                          _vm.handleSortHeaderClick("effectiveDate")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("directory.label.effectiveDate")) +
                          "\n            "
                      ),
                      _c("i", {
                        class: _vm.generateSortClass("effectiveDate"),
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "status",
                      on: {
                        click: function () {
                          _vm.handleSortHeaderClick("status")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("directory.label.status")) +
                          "\n            "
                      ),
                      _c("i", { class: _vm.generateSortClass("status") }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "effective-date",
                      on: {
                        click: function () {
                          _vm.handleSortHeaderClick("removeDate")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("directory.label.removeDate")) +
                          "\n            "
                      ),
                      _c("i", { class: _vm.generateSortClass("removeDate") }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "effective-date",
                      on: {
                        click: function () {
                          _vm.handleSortHeaderClick("publishedAt")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("directory.label.publishedDate")) +
                          "\n            "
                      ),
                      _c("i", { class: _vm.generateSortClass("publishedAt") }),
                    ]
                  ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.searchTableRows, function (row, index) {
              return _c("DirectoryArchivedTableRow", {
                key: row.item.id,
                attrs: {
                  viewType: _vm.viewType,
                  directory: row.item,
                  displayItems: row.displayItems,
                  orderOptions: row.orderOptions,
                  index: index,
                  actionSettings: row.actionSettings,
                  disableAllExceptLinks: false,
                  windowScrollY: _vm.windowScrollY,
                },
              })
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "ActionConfirmModal",
        {
          ref: "removePublishedConfirmModal",
          attrs: {
            confirmTitle: _vm.$t("directory.msg.removePublishedConfirm.title"),
          },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c(
              "div",
              { staticClass: "confirm-remove-table" },
              [
                _c("CommonTable", {
                  ref: "removePublishedConfirmModal",
                  attrs: {
                    needCache: false,
                    tableContentLists: _vm.currentRemoveDirectory,
                    renderHeaderList: _vm.confirmRemoveTableHeader,
                    resizeColumnWhenContentChange: false,
                    defaultOrder: false,
                    needFilter: false,
                    tableId: "confirm-remove-table",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-pure-text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("directory.msg.removePublishedConfirm.message")
                  ) +
                  "\n      "
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }